import React from "react";
import { Form } from "react-bootstrap";
import { useTheme } from "../theme/ThemeProvider";

export default function ThemeSwitcher() {
  const { themeKey, setThemeKey, themes } = useTheme();

  return (
    <Form.Group style={{ minWidth: 220 }}>
      <Form.Label style={{ fontWeight: 600 }}>Colour mode</Form.Label>
      <Form.Select value={themeKey} onChange={(e) => setThemeKey(e.target.value)}>
        {themes.map((t) => (
          <option key={t.key} value={t.key}>
            {t.name} ({t.mode})
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
